<div class="indetificationContainer">
  <div class="identifyContent identifyTitle">
    <h1>iDIN DEMO - Issuer</h1>
  </div>
  <mat-divider></mat-divider>
  <div class="row">&nbsp;</div>
  <div style="text-align: center">
    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdentityVerifiedPage()"
        >
          Success
        </button>
      </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdinCancelledPage()"
        >
          Cancelled
        </button>
      </div>
    </div>
    <div class="row">&nbsp;</div>

    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdinErrorPage()"
        >
          Error
        </button>
      </div>
    </div>
    <div class="row">&nbsp;</div>

    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdinVerificationFailedPage()"
        >
          Verification failed
        </button>
      </div>
    </div>
    <div class="row">&nbsp;</div>

    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdinVerificationMismatchPage()"
        >
          Verification success but data not valid
        </button>
      </div>
    </div>
    <div class="row">&nbsp;</div>

    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdinVerificationExpiredPage()"
        >
          Verification expired
        </button>
      </div>
    </div>

    <div class="row">&nbsp;</div>

    <div class="row">
      <div class="col">
        <button
          class="block"
          type="submit"
          color="primary"
          mat-raised-button
          (click)="goToIdinVerificationOpenPage()"
        >
          Verification open
        </button>
      </div>
    </div>
  </div>
  <div class="row">&nbsp;</div>
  <mat-divider></mat-divider>
</div>
